<template>
  <div class="content">
    <el-form ref="form" :model="form" :rules="rules" :label-position="labelPosition">
      <el-form-item :label="$t('message.feedback_type_title')">
        <el-radio-group v-model="form.type">
          <el-radio label="1">{{ $t("message.feedback_type_option1") }}</el-radio>
          <el-radio label="2">{{ $t("message.feedback_type_option2") }}</el-radio>
          <el-radio label="0">{{ $t("message.feedback_type_option0") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('message.feedback_description')" prop="content">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="form.content" :placeholder="$t('message.feedback_description_placeholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.feedback_contact_email')" prop="email">
        <el-input v-model="form.email" :placeholder="$t('message.feedback_email_placeholder')"></el-input>
      </el-form-item>
      <el-form-item style="text-align:center">
        <el-button type="primary" @click="onSubmit">{{ $t("message.feedback_submit") }}</el-button>
        <el-button @click="onReset">{{ $t("message.feedback_reset") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: 'top',
        rules: {
          content: [
            { required: true, message: this.$i18n.t('message.feedback_tip_content_empty'), trigger: 'blur' },
            { min: 5, max: 1024, message: this.$i18n.t('message.feedback_tip_content_length'), trigger: 'blur' }
          ],
          email: [
            { required: true, message: this.$i18n.t('message.feedback_tip_email_empty'), trigger: 'blur' },
            { type: 'email', message: this.$i18n.t('message.feedback_tip_email_error'), trigger: ['blur', 'change'] }
          ]
        },
        form: {
          uuid: this.$route.query.uuid,
          type: '1',
          content: '',
          email: ''
        }
      }
    },
    mounted() {
      if (this.$route.query.type) {
        this.form.type = this.$route.query.type.toString()
      }
    },
    methods: {
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let params = this.form
            this.$store
            .dispatch('createFeedbackAjax', params)
            .then(response => {
              if (response.code !== 0) {
                this.$message.error(response.message)
              } else {
                this.$message({
                  message: this.$i18n.t('message.feedback_tip_submit_success'),
                  type: 'success',
                  onClose: () => {
                    window.webkit.messageHandlers.h5OnBack.postMessage(null)
                  }
                })
              }
            })
            .catch((error) => {
              this.$message.error(this.$i18n.t('message.feedback_tip_submit_error'))
            })
          }
        })
      },
      onReset() {
        this.$refs['form'].resetFields()
      }
    }
  }

</script>
<style scoped lang="scss">
.content {
  width: 100%;
  padding: 10px 15px;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}

</style>
